var _path, _g, _path2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRibbon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 50,
    viewBox: "0 0 43 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2338_2894",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 43,
    height: 9
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.503906 0H42.4109V8.40285H0.503906V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2338_2894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.339 0.0322266H6.88676C6.24561 0.0322266 5.63173 0.16352 5.03832 0.426111C4.45173 0.688698 3.92653 1.0607 3.47636 1.54211C3.02619 2.02353 2.67832 2.57788 2.43277 3.21247C2.18723 3.83977 2.06445 4.49624 2.06445 5.1746V34.0448H41.1545V5.1746C41.1545 4.49624 41.0317 3.83977 40.793 3.21247C40.5474 2.57788 40.1996 2.02353 39.7494 1.54211C39.2924 1.0607 38.774 0.688698 38.1806 0.426111C37.594 0.16352 36.9801 0.0322266 36.339 0.0322266Z",
    fill: "#724C33"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2338_2894",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 38,
    height: 50
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.503906 0H37.1725V49.0166H0.503906V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2338_2894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.88676 0.0253906C6.2456 0.0253906 5.63173 0.126979 5.03832 0.330158C4.45173 0.533334 3.92653 0.82117 3.47636 1.19366C3.02619 1.56616 2.67832 1.99509 2.43277 2.4861C2.18723 2.97147 2.06445 3.47941 2.06445 4.00429V44.4536C2.06445 44.9841 2.18723 45.4977 2.4396 45.9887C2.68514 46.4854 3.033 46.92 3.49 47.2924C3.94699 47.6706 4.47219 47.9641 5.07243 48.1672C5.66584 48.3704 6.28653 48.472 6.9345 48.472H26.4897C27.1377 48.472 27.7584 48.3704 28.3518 48.1672C28.9521 47.9641 29.4773 47.6706 29.9343 47.2924C30.3912 46.92 30.7391 46.4854 30.9847 45.9887C31.237 45.4977 31.3598 44.9841 31.3598 44.4536V4.00429C31.3598 3.47941 31.4758 2.97147 31.7213 2.4861C31.9669 1.99509 32.3147 1.56616 32.7649 1.19366C33.2219 0.82117 33.7403 0.533334 34.3337 0.330158C34.9203 0.126979 35.5341 0.0253906 36.1753 0.0253906H6.88676Z",
    fill: "#B26D3E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibbon);
export default __webpack_public_path__ + "static/media/ribbon.bbfd4c0157255375b8f84212d728aae1.svg";
export { ForwardRef as ReactComponent };